import { render, staticRenderFns } from "./schoolResource.vue?vue&type=template&id=1a9274a4&scoped=true&"
import script from "./schoolResource.vue?vue&type=script&lang=js&"
export * from "./schoolResource.vue?vue&type=script&lang=js&"
import style0 from "./schoolResource.vue?vue&type=style&index=0&id=1a9274a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9274a4",
  null
  
)

export default component.exports